import { CLOSE_MODAL, OPEN_MODAL } from '../actions/ActionTypes';
const initialState = {
  modalProps: {},
  modalType: null
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      {
        const {
          modalType,
          modalProps
        } = action;
        return Object.assign({}, state, {
          modalType,
          modalProps
        });
      }
    case CLOSE_MODAL:
      return initialState;
    default:
      return state;
  }
});